import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { genericJourneyResolverMapping, wizardJourneyResolverMapping } from '@dxb-web-ui-framework/mocks/msw/types';
import { genericMapToHandlers } from '@dxb-web-ui-framework/mocks/msw/utils/genericMapToHandlers';
import { wizardFlowMapToHandlers } from '@dxb-web-ui-framework/mocks/msw/utils/wizardFlowMapToHandlers';
import { ecommbx } from '../../index';

const issueCardJourneyStepData: GenericObject = {
  PRODUCT_SELECTOR: {
    next: ecommbx.issueCardAccountSelectorData,
    prev: {},
    actions: {},
  },
  ACCOUNT_SELECTOR: {
    next: ecommbx.issueCardVerifyData,
    prev: ecommbx.issueCardStartData,
    actions: {},
  },
  VERIFY: {
    next: ecommbx.issueCardAuthorizationData,
    prev: ecommbx.issueCardAccountSelectorData,
    actions: {},
  },
  AUTHORIZATION: {
    next: ecommbx.issueCardEndData,
    prev: ecommbx.issueCardVerifyData,
    actions: {},
  },
  END: {
    next: {},
    prev: {},
    actions: {},
  },
};

const issueCorporateCardJourneyStepData: GenericObject = {
  PRODUCT_SELECTOR: {
    next: ecommbx.issueCorporateCardAccountSelectorData,
    prev: ecommbx.issueCorporateCardStartData,
    actions: {},
  },
  ACCOUNT_SELECTOR: {
    next: ecommbx.issueCorporateCardVerifyData,
    prev: ecommbx.issueCorporateCardProductSelectorData,
    actions: {},
  },
  PARTY_SELECTOR: {
    next: ecommbx.issueCorporateCardProductSelectorData,
    prev: {},
    actions: {},
  },
  VERIFY: {
    next: ecommbx.issueCorporateCardAuthorizationData,
    prev: ecommbx.issueCorporateCardAccountSelectorData,
    actions: {},
  },
  AUTHORIZATION: {
    next: ecommbx.issueCorporateCardEndData,
    prev: ecommbx.issueCorporateCardVerifyData,
    actions: {},
  },
  END: {
    next: {},
    prev: {},
    actions: {},
  },
};

const topUpJourneyStepData: GenericObject = {
  FROM_ACCOUNT_AND_AMOUNT: {
    next: ecommbx.topupCardExternalPaymentData,
    prev: {},
    actions: {},
  },
  PAYMENT_CARD_EXTERNAL: {
    next: ecommbx.topupCardVerifyData,
    prev: {},
    actions: {},
  },
  VERIFY: {
    next: ecommbx.topupCardAuthorizationData,
    prev: ecommbx.topupCardStartData,
    actions: {},
  },
  AUTHORIZATION: {
    next: ecommbx.topupCardEndData,
    prev: ecommbx.topupCardVerifyData,
    actions: {},
  },
  END: {
    next: {},
    prev: {},
    actions: {},
  },
  GENERIC_ERROR: {
    next: {},
    prev: {},
    actions: {},
  },
};

const terminateJourneyStepData: GenericObject = {
  ACCOUNT_SELECTOR: {
    next: ecommbx.terminateCardVerifyData,
    prev: {},
    actions: {},
  },
  VERIFY: {
    next: ecommbx.terminateCardAuthorizationData,
    prev: ecommbx.terminateCardStartData,
    actions: {},
  },
  AUTHORIZATION: {
    next: ecommbx.terminateCardResultData,
    prev: ecommbx.terminateCardVerifyData,
    actions: {},
  },
  RESULT: {
    next: {},
    prev: {},
    actions: {},
  },
  GENERIC_ERROR: {
    next: {},
    prev: {},
    actions: {},
  },
};

const replaceJourneyStepData: GenericObject = {
  CARD_TERMINATE_REASON: {
    next: ecommbx.replaceCardAccountSelectorData,
    prev: {},
    actions: {},
  },
  ACCOUNT_SELECTOR: {
    next: ecommbx.replaceCardVerifyData,
    prev: ecommbx.replaceCardStartData,
    actions: {},
  },
  VERIFY: {
    next: ecommbx.terminateCardAuthorizationData,
    prev: ecommbx.replaceCardAccountSelectorData,
    actions: {},
  },
  AUTHORIZATION: {
    next: ecommbx.replaceCardResultData,
    prev: ecommbx.replaceCardVerifyData,
    actions: {},
  },
  RESULT: {
    next: {},
    prev: {},
    actions: {},
  },
  GENERIC_ERROR: {
    next: {},
    prev: {},
    actions: {},
  },
};

const permanentBlockJourneyStepData: GenericObject = {
  CARD_TERMINATE_REASON: {
    next: ecommbx.permanentBlockCardVerifyData,
    prev: {},
    actions: {},
  },
  VERIFY: {
    next: ecommbx.permanentBlockCardAuthorizationData,
    prev: ecommbx.permanentBlockCardStartData,
    actions: {},
  },
  AUTHORIZATION: {
    next: ecommbx.permanentBlockCardResultData,
    prev: ecommbx.permanentBlockCardVerifyData,
    actions: {},
  },
  RESULT: {
    next: {},
    prev: {},
    actions: {},
  },
  GENERIC_ERROR: {
    next: {},
    prev: {},
    actions: {},
  },
};

const cardsMap: genericJourneyResolverMapping[] = [
  {
    url: /\/payment-card\/prepaid\/transactions\/export/,
    response: () => ecommbx.cardTransactionsExportData,
    method: 'post',
  },
  {
    url: /\/payment-card\/prepaid\/transactions/,
    response: () => ecommbx.cardTransactionsData,
    method: 'post',
  },
  {
    url: /\/api\/private\/cards\/\d+\/transaction\/\d+/,
    response: () => ecommbx.cardTransactionDetailsData,
    method: 'get',
  },
  {
    url: /\/customer-products\/card-info\/list/,
    response: () => ecommbx.cardData,
    method: 'post',
  },
  {
    url: /\/customer-products\/card-info\/statuses/,
    response: () => ecommbx.cardStatusesData,
    method: 'get',
  },
  {
    url: /\/customer-products\/card-info\/corporate\/list/,
    response: () => ecommbx.cardData,
    method: 'post',
  },
  {
    url: /\/payment-card\/prepaid\/details/,
    response: () => ecommbx.cardDetailsData,
    method: 'post',
  },
  {
    url: /\/api\/private\/cards\/parameters\/statuses/,
    response: () => ecommbx.cardStatusesData,
    method: 'get',
  },
  {
    url: /\/api\/private\/cards\/topup/,
    response: () => ecommbx.initTopUpAuthorizationData,
    method: 'get',
  },
  {
    url: /\/api\/private\/cards\/topup\/post/,
    response: () => ecommbx.postTopUpData,
    // responseStatusCode: 400,
  },
  {
    url: /\/payment-card\/prepaid\/freeze-unfreeze/,
    response: () => ecommbx.cardFreeze,
    method: 'post',
  },
  {
    url: /\/api\/private\/cards\/authorization/,
    response: () => ecommbx.cardAuthorizationData,
    method: 'get',
  },
  {
    url: /\/api\/private\/cards\/\d+\/terminate/,
    response: () => null,
    method: 'post',
  },
  {
    url: /\/secure-web\/dx4b\/login\/post-login/,
    response: () => ecommbx.cardHeadersResponse,
    method: 'post',
  },
];

const issueCardJourneyMap: wizardJourneyResolverMapping[] = [
  { url: /\/card-issue\/start/, response: () => ecommbx.issueCardStartData },
  {
    url: /\/card-issue\/next/,
    response: (step?: string) => step && issueCardJourneyStepData[step].next,
  },
  {
    url: /\/card-issue\/previous/,
    response: (step?: string) => step && issueCardJourneyStepData[step].prev,
  },
  {
    url: /\/card-issue\/action/,
    response: (step?: string, action?: string) => step && action && issueCardJourneyStepData[step].actions[action],
    method: 'put',
  },
];

const issueCorporateCardJourneyMap: wizardJourneyResolverMapping[] = [
  { url: /\/card-issue-corporate\/start/, response: () => ecommbx.issueCorporateCardStartData },
  {
    url: /\/card-issue-corporate\/next/,
    response: (step?: string) => step && issueCorporateCardJourneyStepData[step].next,
  },
  {
    url: /\/card-issue-corporate\/previous/,
    response: (step?: string) => step && issueCorporateCardJourneyStepData[step].prev,
  },
  {
    url: /\/card-issue-corporate\/action/,
    response: (step?: string, action?: string) =>
      step && action && issueCorporateCardJourneyStepData[step].actions[action],
    method: 'put',
  },
];

const topUpJourneyMap: wizardJourneyResolverMapping[] = [
  { url: /\/top-up\/start/, response: () => ecommbx.topupCardStartData },
  {
    url: /\/top-up\/next/,
    response: (step?: string) => step && topUpJourneyStepData[step].next,
  },
  {
    url: /\/top-up\/previous/,
    response: (step?: string) => step && topUpJourneyStepData[step].prev,
  },
  {
    url: /\/top-up\/action/,
    response: (step?: string, action?: string) => step && action && topUpJourneyStepData[step].actions[action],
    method: 'put',
  },
];

const terminateJourneyMap: wizardJourneyResolverMapping[] = [
  { url: /\/card-terminate\/start/, response: () => ecommbx.terminateCardStartData },
  {
    url: /\/card-terminate\/next/,
    response: (step?: string) => step && terminateJourneyStepData[step].next,
  },
  {
    url: /\/card-terminate\/previous/,
    response: (step?: string) => step && terminateJourneyStepData[step].prev,
  },
  {
    url: /\/card-terminate\/action/,
    response: (step?: string, action?: string) => step && action && terminateJourneyStepData[step].actions[action],
    method: 'put',
  },
];

const replaceJourneyMap: wizardJourneyResolverMapping[] = [
  { url: /\/card-replace\/start/, response: () => ecommbx.replaceCardStartData },
  {
    url: /\/card-replace\/next/,
    response: (step?: string) => step && replaceJourneyStepData[step].next,
  },
  {
    url: /\/card-replace\/previous/,
    response: (step?: string) => step && replaceJourneyStepData[step].prev,
  },
  {
    url: /\/card-replace\/action/,
    response: (step?: string, action?: string) => step && action && replaceJourneyStepData[step].actions[action],
    method: 'put',
  },
];

const permanentBlockJourneyMap: wizardJourneyResolverMapping[] = [
  { url: /\/card-permanent-block\/start/, response: () => ecommbx.permanentBlockCardStartData },
  {
    url: /\/card-permanent-block\/next/,
    response: (step?: string) => step && permanentBlockJourneyStepData[step].next,
  },
  {
    url: /\/card-permanent-block\/previous/,
    response: (step?: string) => step && permanentBlockJourneyStepData[step].prev,
  },
  {
    url: /\/card-permanent-block\/action/,
    response: (step?: string, action?: string) => step && action && permanentBlockJourneyStepData[step].actions[action],
    method: 'put',
  },
];

const cardsHandler = cardsMap.map(genericMapToHandlers);
const issueCardHandler = issueCardJourneyMap.map(wizardFlowMapToHandlers);
const issueCorporateCardHandler = issueCorporateCardJourneyMap.map(wizardFlowMapToHandlers);
const topupCardHandler = topUpJourneyMap.map(wizardFlowMapToHandlers);
const terminateCardHandler = terminateJourneyMap.map(wizardFlowMapToHandlers);
const replaceCardHandler = replaceJourneyMap.map(wizardFlowMapToHandlers);
const permanentBlockCardHandler = permanentBlockJourneyMap.map(wizardFlowMapToHandlers);

export {
  cardsHandler,
  issueCardHandler,
  topupCardHandler,
  terminateCardHandler,
  replaceCardHandler,
  issueCorporateCardHandler,
  permanentBlockCardHandler,
};
